<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/500.min.svg"
    alt="500"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIcon500',
})
</script>
